import { Component, ElementRef, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { View } from "ol";
import TileLayer from "ol/layer/Tile";
import { OSM } from "ol/source";
import axios from "src/app/Service/axios";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import * as XLSX from 'xlsx';
import Map from 'ol/Map';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import * as olProj from 'ol/proj';
import { MapService } from "src/app/Service/map.service";
import momentJalaali from "moment-jalaali";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
declare let $: any;

@Component({
  selector: 'manageSos',
  templateUrl: './manageSosComponent.html',
})
export class ManageSosComponent implements OnInit {
  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private mapService: MapService,
    private gurdService: GurdServiceService

  ) {

  }
  datatFrom: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  SosData: any = [];
  fullSosData: any = [];
  fileName = 'LiveJournal.xlsx';
  location: any = [51.3833554, 35.6770113];
  map: any;
  dateTime:Date=new Date();
  GeoFenceData:any;
  domain: any;
  ismapCreate: boolean = false;
  DateTimeModel:any="";
  strDate:FormControl =new FormControl( momentJalaali().format('jYYYY/jMM/jDD'))
  ngOnInit(): void {
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
var sTime=document.getElementById("sTime") as any;

sTime.value=`${this.dateTime.getHours()}:${this.dateTime.getMinutes()}`
    this.getArea();
    this.getDomain();
  }
  search(){
    var Interval;
    clearInterval(Interval);

    this.getSos();
    this.SosData=[];
    this.fullSosData=[];
  
    Interval = setInterval(() => {
      this.getSos();
    }, 30000);
  }

  getArea = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };
    const resp = await axios.post(`Radyab_GeoFence`, model);
    let respJson = JSON.parse(resp.data);
    this.GeoFenceData = respJson;
  };
  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
  newOpenMap() {

    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'map-modal',
      layers: [
        new TileLayer({
          source: new OSM({}),
        })
      ],
      view: new View({
        center: olProj.fromLonLat(this.location),
        zoom: 5,
      }),
    }) as any;
  }
  openMap(flat: any, fLon: any, time: any, comment: any) {
    if (!this.ismapCreate) {
      this.newOpenMap();
      this.ismapCreate = true;
    }
    this.mapService.removeMarkerById("marker", this.map);
    var marker = this.mapService.createMarker([fLon, flat],
      '../../assets/Img/marker5.png',
      `marker`,
      ``,
      {
        html: `
        <p class='text-dark mb-0 f12'>${comment}</p>
        `,
      });
    this.map.addLayer(marker);
    this.mapService.fitMap([{ fLon: fLon, fLat: flat }], this.map);
    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }
        setTimeout(() => {
          var el = this.mapService.mapPointerMove(
            this.map.getEventPixel(e.originalEvent),
            this.map
          );
          this.showData(el);

        }, 50);
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 500);
  }
  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        tooltip
          .attr(
            'data-bs-original-title',
            item.featureLayer.feature.get('data').html
          )
          .tooltip('show');
      }
    } else {
      tooltip.tooltip('hide');
    }
  }
 

getSos = async () => {

var sTime=document.getElementById("sTime") as any;

  var model = {
    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    strDate  :this.datatFrom.value.date,
    strTime :sTime.value,
    strDateTime:this.DateTimeModel
  }

  this.otherService.Showspinner();
  const resp = await axios.post(
    `Radyab_SearchSOS`,model
  );
  this.otherService.nonespinner();
  // this.eventModel.controls["strDate"].setValue("");
  // this.eventModel.controls["strTime"].setValue("");
  JSON.parse(resp.data).forEach((element: any) => {
    this.SosData.push(element);
    this.fullSosData.push(element);
  });

if (JSON.parse(resp.data).length == 0) {
  const dateTime = await axios.post(`GetCurrentDateTime`, {});
  this.DateTimeModel=dateTime.data;
 // this.eventModel.controls["DateTime"].setValue(dateTime.data);
}
else {
  this.DateTimeModel=this.SosData[0].strCurrentDateTime;
  //this.eventModel.controls["DateTime"].setValue(this.EventsData[0].strCurrentDateTime);
}

  if ($('#show-last-th').is(":checked")) {
    setTimeout(() => {
      var scrollsave = $('#scroll-handel').prop('scrollHeight');
      $('#scroll-handel').animate({ scrollTop: scrollsave }, 1000);

    }, 100);

  }
}
  // sortByDate() {
  //   this.EventsData.sort((a: any, b: any) => {
  //     return new Date(b.strDate) as any - (new Date(a.strDate) as any);
  //   });
  // }
}
